<template lang="pug">
  div
    v-card.MultipleOptionQuestion(v-if="currentStep.question" flat)
      v-card-text.title
        | {{currentStep.question.title}}
        ul.list(v-if="currentStep.question.list")
          li(v-for="l in currentStep.question.list") {{l}}
      v-flex.answers(xs10, sm15, md12)
            div.answers(v-for="option in currentStep.question.options")
                span.check(v-if="currentStep.check")
                v-flex.checkbox-container(xs12)
                  v-icon.true-false-checks-icon(size='25px' color="green" v-if="!option.retry && currentStep.check") check
                  v-icon.true-false-checks-icon(size='25px' color="red" v-if="option.retry == true && currentStep.check") close
                  v-checkbox.checkbox(:readonly="currentStep.check" :label="option.label" style="margin-top: -7px;" hide-details v-model="answers" :value="option" @change="changeValue(option)")
    el-button.ButtonSend(@click.stop.prevent="setRetro" type="success" :disabled="!answered" v-show="!currentStep.check") Revisar
</template>

<script>

import { mapGetters } from 'vuex';
//import { debug } from 'util';

export default {
  name: 'MultipleOptionQuestionFeedback',
  computed: {
    ...mapGetters(['currentStep']),
    answered(){
      return this.answers.length>0;
    }
  },
  data() {
    return {
      isDisabled: true,
      mostrar: true,
      cuenta: 0,
      answers:[]
    }
  },
  mounted: function(){
     this.answers = this.currentStep.question.answer;
  },
  watch: {
    currentStep: {
      handler(val) {        
        this.show = val.check || false;
        this.checkretry();
      },
      deep: true,
    }
  },
  methods: {
    changeValue(option) {
    },
    setRetro(event){
      this.mostrar = false;
      this.currentStep.state = true;
      this.currentStep.check = true;
      this.currentStep.question.answer = this.answers;
      this.$emit('answered',this.currentStep.question.answer);
    }
  }
}
</script>

<style scoped>
@import 'multiple-option-question.scss';
</style>
